import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageType } from '../../shared/models/enums/pageType';
import { StaticPagesService } from '../../shared/services/static-page/static-pages.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-frequently-asked-questions',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './frequently-asked-questions.component.html',
  styleUrl: './frequently-asked-questions.component.scss',
})
export class FrequentlyAskedQuestionsComponent implements OnInit {
  @Input() count: number = 0;
  constructor(
    private staticPagesService: StaticPagesService,
    public router: Router
  ) {}

  questions: any;
  openIndex: number | null = null; // Hangi sorunun açık olduğunu tutacak
  
  ngOnInit(): void {
    this.staticPagesService
      .getByPageType(PageType.FrequentlyAskedQuestions, this.router.url === '/')
      .subscribe((data) => {
        if (this.count > 0) this.questions = data.slice(0, this.count);
        else this.questions = data;
      });
  }

  toggleAccordion(index: number) {
    this.openIndex = this.openIndex === index ? null : index; // Aynı başlığa tıklandığında kapat
  }
  
}
